import React from "react";
import { AvatarChat } from "../avatar-chat";
import { DotsLoader } from "../dots-loader";
import classNames from "classnames";

const INTENT_CLASSES = {
  light: ["bg-light-neutral-5", "text-black", "rounded-xl"],
  dark: ["bg-dark-neutral-4", "text-white", "rounded-base"],
};

export type ChatQuestionProps = {
  text: string;
  typing?: boolean;
  firstName?: string;
  lastName?: string;
  reverse?: boolean;
  intent?: "light" | "dark";
  date?: string;
};

export function ChatQuestion({
  text,
  typing,
  firstName,
  lastName,
  reverse,
  intent = "dark",
  date,
}: ChatQuestionProps) {
  const firstLetter = firstName && firstName.length > 0 ? firstName[0] : "N/A";
  const lastLetter = lastName && lastName.length > 0 && firstLetter !== "N/A" ? lastName[0] : "";

  return (
    <>
      <div
        className={classNames([
          `flex text-sans-serif p-5`,
          INTENT_CLASSES[intent],
          reverse ? "flex-row-reverse justify-end" : "justify-between",
        ])}
        style={{
          ...(intent === "light"
            ? {
                borderTopRightRadius: 0,
              }
            : {}),
        }}
      >
        <div className={classNames(["", reverse ? "ml-4" : "mr-4"])}>
          {firstName && (
            <div className='flex font-normal items-center mb-2.5'>
              <div className='font-semibold text-xs'>{firstName}</div>
              {date && <div className='ml-2.5 text-xs text-mid-neutral-1'>{date}</div>}
            </div>
          )}
          <div className='text-sm font-normal whitespace-pre-line'>{text}</div>
        </div>
        <AvatarChat
          width={40}
          {...(firstName ? { shortName: `${firstLetter}${lastLetter}` } : { noName: true })}
        />
      </div>
      {typing && (
        <div className='pl-5 my-10'>
          <DotsLoader />
        </div>
      )}
    </>
  );
}
